export function FlightDateTimeFields({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const [date = '', time = ''] = value.split('T');
  const normalizeTime = (text: string) => {
    const compact = text.trim();
    if (/^\d{4}$/.test(compact)) return `${compact.slice(0, 2)}:${compact.slice(2)}`;
    const parts = /^(\d{1,2}):(\d{1,2})$/.exec(compact);
    return parts ? `${parts[1]!.padStart(2, '0')}:${parts[2]!.padStart(2, '0')}` : text;
  };
  return (
    <fieldset className="flightDateTimeFields">
      <legend>{label}</legend>
      <label>
        <span>Data de {label.toLowerCase()}</span>
        <input
          type="date"
          required
          value={date}
          onChange={(e) => onChange(`${e.target.value}T${time}`)}
        />
      </label>
      <label>
        <span>Horário de {label.toLowerCase()}</span>
        <input
          type="text"
          required
          inputMode="numeric"
          autoComplete="off"
          placeholder="HH:mm"
          pattern="([01][0-9]|2[0-3]):[0-5][0-9]"
          title="Informe um horário de 00:00 a 23:59"
          maxLength={5}
          value={time}
          onChange={(e) => onChange(`${date}T${e.target.value}`)}
          onBlur={() => {
            const normalized = normalizeTime(time);
            if (normalized !== time) onChange(`${date}T${normalized}`);
          }}
        />
      </label>
    </fieldset>
  );
}
